import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import { SpaceCreationDialog } from '../../../Components';
import { useCurrentOrganization } from '../../../state';

/**
 * Button to create a translated space.
 */
export function CreateTranslatedSpaceButton(props: Partial<ButtonProps>) {
    const organization = useCurrentOrganization();
    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    leadingIcon={Icon.Plus}
                    label="Create translation"
                    kind="primary"
                    {...props}
                    disabled={!organization.permissions.createContent}
                    tooltip={
                        organization.permissions.createContent
                            ? undefined
                            : {
                                  label: `You don't seem to have permission to create translations. Reach out to your organization's admin to get "Creator" or "Administrator" role.`,
                              }
                    }
                />
            </DialogTrigger>
            <SpaceCreationDialog
                target={{ type: 'space' }}
                organizationId={organization.id}
                defaultOpenTranslation
            />
        </DialogRoot>
    );
}
